export enum WillSectionKey {
  PERSONAL_INFORMATION = 'personal-information',
  SPOUSE_INFORMATION = 'spouse-information',
  PARTNER_INFORMATION = 'partner-information',
  CHILDREN_INFORMATION = 'children-information',
  EXECUTOR_INFORMATION = 'executor-information',
  ALTERNATE_EXECUTOR_INFORMATION = 'alternate-executor-information',
  MINOR_CHILDREN_GUARDIANS = 'minor-children-guardians',
  SPECIFIC_BENEFICIARIES = 'specific-beneficiaries',
  RESIDUAL_BENEFICIARIES = 'residual-beneficiaries',
  ALTERNATE_BENEFICIARIES = 'alternate-beneficiaries',
  STAGED_DISTRIBUTION = 'staged-distribution',
  LAST_WISHES = 'last-wishes',
  CEMETERY_PROPERTY = 'cemetery-property'
}
